module.exports = __webpack_public_path__ + "img/boy_icon.1bf685ac.png";